import { takeLatest, put, select } from 'redux-saga/effects';
import {
  GET_TICKETS_SUCCESS,
  GET_TICKETS,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  SET_LOADING,
  REQUEST_ERROR,
  GET_REFERENCE_DATA,
  GET_REFERENCE_DATA_SUCCESS,
  ADD_TICKET_RESPONSE,
  ADD_TICKET_RESPONSE_SUCCESS,
} from '../types/ticket';

import { requestListApi, requestDetailApi, requestAddTicketResponseApi } from '../requests/ticket';

import { onFailRequest } from '@/utils';

/**
 * Get reference data
 * @param {*} payload
 */
function* getReferenceData(payload) {
  try {
    yield put({
      type: GET_REFERENCE_DATA_SUCCESS,
      data: {},
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
    });
  }
}

/**
 * Get tickets with pagination
 * @param {*} payload
 */
function* getList(payload) {
  try {
    const response = yield requestListApi(payload);
    yield getReferenceData(payload);
    yield put({
      type: GET_TICKETS_SUCCESS,
      data: response,
    });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: REQUEST_ERROR });
      },
    });
  }
}

/**
 * Get detail data ticket
 * @param {*} payload
 */
function* getDetail(payload) {
  try {
    const { id } = payload;
    const data = yield requestDetailApi(id);
    yield put({ type: GET_DETAIL_SUCCESS, data });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        yield put({ type: SET_LOADING, isLoading: false });
      },
    });
  }
}

/**
 * Post add ticket response
 * @param {*} payload
 * @param callback
 */
function* addTicketResponse({ payload, callback }) {
  try {
    const state = yield select();
    const staffId = state.authenticate.user.id;
    const response = yield requestAddTicketResponseApi({
      staffId,
      ...payload,
    });
    const { data } = response;
    yield put({ type: ADD_TICKET_RESPONSE_SUCCESS, payload: data });
    callback({ response });
  } catch (error) {
    yield onFailRequest({
      payload,
      error,
      *onCallback() {
        callback({ error });
      },
    });
  }
}

export default [
  takeLatest(GET_TICKETS, getList),
  takeLatest(GET_DETAIL, getDetail),
  takeLatest(GET_REFERENCE_DATA, getReferenceData),
  takeLatest(ADD_TICKET_RESPONSE, addTicketResponse),
];
